// src/components/shared/ShareModal.js
import React, { useState } from "react";
import Modal from "../ui/Modal";
import Button from "../ui/Button";
import {
  Link2,
  Check,
  Twitter,
  Facebook,
  MessageCircle,
  Send,
} from "lucide-react";

const ShareModal = ({
  isOpen,
  onClose,
  postUrl,
  text = "Check out this post!",
}) => {
  const [copied, setCopied] = useState(false);

  const encodedUrl = encodeURIComponent(postUrl);
  const encodedText = encodeURIComponent(text);

  const socialPlatforms = [
    {
      name: "WhatsApp",
      icon: MessageCircle,
      url: `https://api.whatsapp.com/send?text=${encodedText}%20${encodedUrl}`,
    },
    {
      name: "Twitter",
      icon: Twitter,
      url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`,
    },
    {
      name: "Facebook",
      icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    },
    {
      name: "Telegram",
      icon: Send,
      url: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`,
    },
  ];

  const handleCopy = () => {
    navigator.clipboard.writeText(postUrl);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
      onClose();
    }, 1500);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Share Post">
      <div className="p-4 space-y-4">
        {/* Social Share Buttons */}
        <div className="grid grid-cols-4 gap-4 text-center">
          {socialPlatforms.map(({ name, icon: Icon, url }) => (
            <a
              key={name}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center gap-2 text-slate-600 hover:text-primary transition-colors"
            >
              <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center">
                <Icon size={24} />
              </div>
              <span className="text-xs">{name}</span>
            </a>
          ))}
        </div>

        {/* Copy Link Section */}
        <div>
          <p className="text-sm text-slate-600 mb-2 mt-4 pt-4 border-t border-slate-200">
            Or copy link
          </p>
          <div className="flex items-center space-x-2">
            <input
              type="text"
              readOnly
              value={postUrl}
              className="flex-grow p-2 bg-slate-100 border border-slate-200 rounded-md text-sm"
            />
            <Button
              onClick={handleCopy}
              variant={copied ? "secondary" : "primary"}
              className="!px-3"
            >
              {copied ? <Check size={20} /> : <Link2 size={20} />}
            </Button>
          </div>
          {copied && (
            <p className="text-center text-sm text-green-600 font-semibold mt-4">
              Copied to clipboard!
            </p>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ShareModal;
